import utils from '../../../../utils';

const checkAnswers = (data) => {
  const allAnswersCount = data.length;
  let rightAnswersCount = 0;
  let answers = [];

  data.forEach((item) => {
    const currentAnswer = {};
    currentAnswer.question = item.question;

    item.answers.forEach((answer) => {
      if (answer?.isRightAnswer) {
        const rightAnswer = document.getElementById(
          utils.createURLChunk(answer.text, true)
        ).checked;

        if (rightAnswer) {
          ++rightAnswersCount;
          currentAnswer.isRight = true;
        } else {
          currentAnswer.isRight = false;
          currentAnswer.rightAnswer = item.answers.find(
            (item) => item?.isRightAnswer === true
          ).text;
        }
      }
    });

    return answers.push(currentAnswer);
  });

  return {
    answers: answers,
    total: {
      allAnswersCount: allAnswersCount,
      rightAnswersCount: rightAnswersCount,
    },
  };
};

export default checkAnswers;
